import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../../Symbols/Title';
import Seat from './Seat';
import { Mandates, Seating, Seats } from './styles';
import { RegionalParty } from '../../../types';

const filterPartiesWithMandates = (parties) =>
	parties.filter((party) => party.mandates.count > 0);

export const MandatesComposition = ({ parties }) => {
	const partiesWithMandates = filterPartiesWithMandates(parties);

	return (
		<Mandates>
			<Title>Složení zastupitelů</Title>
			<Seating>
				<Seats>
					{partiesWithMandates.map((party) =>
						party.mandates.list.map((representative) => (
							<Seat key={representative.id} party={party} {...representative} />
						))
					)}
				</Seats>
			</Seating>
		</Mandates>
	);
};

MandatesComposition.propTypes = {
	parties: PropTypes.arrayOf(PropTypes.shape(RegionalParty))
};
